import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'

import PanelCurrencyInformation from '../PanelCurrencyInformation'
import PanelCurrencyBalance from '../PanelCurrencyBalance'
import PanelCurrencySymbol from '../PanelCurrencySymbol'
import PanelCurrencyName from '../PanelCurrencyName'
import PanelCurrencyLogo from '../PanelCurrencyLogo'
import { coinImage } from '../../assets/coins/coins'
import { Popup } from '../catalog/Popup'
import { Token } from '../../logic/token/token'

const _SwapCurrencySelector = styled.div<{ isValidateCurrencyChoice: boolean }>`
  width: 400px;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  opacity: ${({ isValidateCurrencyChoice }) =>
    isValidateCurrencyChoice ? '1' : '0.3'};
  cursor: ${({ isValidateCurrencyChoice }) =>
    isValidateCurrencyChoice ? 'pointer' : 'default'};

  &:hover {
    background-color: ${({ theme }) =>
      theme.tradeCurrencySelectorBackgroundColorHover};
  }

  /* Mobiles */
  @media (max-width: 640px) {
    width: 90%;
  }
`

interface SwapCurrencySelectorProps {
  currency: Token
  validateCurrency: (token: Token) => boolean
  selectCurrency: (token: Token) => void
}
function SwapCurrencySelector(props: SwapCurrencySelectorProps) {
  const [isValidateCurrencyChoice, setIsValidateCurrencyChoice] = useState(true)
  const coin = props.currency['symbol'].toLowerCase()
  // TODO: get a default icon ?
  const src = coinImage(coin)!

  useEffect(() => {
    async function validate() {
      const v = await props.validateCurrency(props.currency)
      setIsValidateCurrencyChoice(v)
    }
    validate()
  }, [props.currency])
  return (
    <_SwapCurrencySelector
      isValidateCurrencyChoice={isValidateCurrencyChoice}
      onClick={(e: any) => props.selectCurrency(props.currency)}
    >
      <div
        style={{ display: 'flex' }}
        data-cy={'selector-' + props.currency['symbol'].toLowerCase()}
      >
        <PanelCurrencyLogo src={src} />
        <PanelCurrencyInformation>
          <PanelCurrencySymbol className={'coin-symbol'}>
            {props.currency['symbol']}
          </PanelCurrencySymbol>
          <PanelCurrencyName className={'coin-name'}>
            {props.currency['name']}
          </PanelCurrencyName>
        </PanelCurrencyInformation>
      </div>
      <div>
        <PanelCurrencyBalance
          tokenTargetQuantity={undefined}
          token={props.currency}
        />
      </div>
    </_SwapCurrencySelector>
  )
}

interface PanelProps {
  onExit: VoidFunction
  currencies: Token[]
  validateCurrency: (token: Token) => boolean
  selectCurrency: (token: Token) => void
}
function SwapCurrencySelectorPanel(props: PanelProps) {
  const ref = useRef()
  return (
    <Popup
      onExit={props.onExit}
      outsideRef={ref}
      title={'Select a token'}
      removePadding
    >
      {Object.values(props.currencies).length > 0 ? (
        Object.values(props.currencies).map((currency, index) => (
          <SwapCurrencySelector
            validateCurrency={props.validateCurrency}
            selectCurrency={props.selectCurrency}
            key={index}
            currency={currency}
          />
        ))
      ) : (
        <div
          style={{
            alignSelf: 'center',
            padding: '0.35em',
            borderRadius: '10px',
          }}
        >
          No token found 🥺
        </div>
      )}
    </Popup>
  )
}

const _SwapCurrencySelectorPanelWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) =>
    theme.swapCurrencySelectorPanelWrapperBackgroundColor};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  z-index: 50;
`
interface WrapperProps {
  onExit: VoidFunction
  showCurrencySelector: boolean
  currencies: Token[]
  validateCurrency: (token: Token) => boolean
  selectCurrency: (token: Token) => void
}
function SwapCurrencySelectorPanelWrapper(props: WrapperProps) {
  return (
    <>
      {props.showCurrencySelector ? (
        <_SwapCurrencySelectorPanelWrapper>
          <SwapCurrencySelectorPanel
            validateCurrency={props.validateCurrency}
            selectCurrency={props.selectCurrency}
            onExit={props.onExit}
            currencies={props.currencies}
          />
        </_SwapCurrencySelectorPanelWrapper>
      ) : (
        <>{/* TODO: the property should not exist */}</>
      )}
    </>
  )
}

export default SwapCurrencySelectorPanelWrapper
